import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { DragDropData } from '../../../models/drag-drop-data';
import { GenericColDef } from '../../../models/grid-context';

export interface DragDropCellParams extends ICellRendererParams {
    showDragDots: boolean;
    showCheckboxes: boolean;
    isRowDeletable: boolean;
    dragScope: (item: DragDropData) => string[];
    dropScope: (item: DragDropData) => string[];
    onDrop: (dragData: DragDropData, dropData: DragDropData) => void;
}

@Component({
    standalone: false,
    templateUrl: './drag-drop-cell.component.html',
    styleUrls: ['./drag-drop-cell.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DragDropCellComponent implements ICellRendererAngularComp {
    params: DragDropCellParams;
    colDef: GenericColDef;
    automationId: string;
    @Input() isDisabled: boolean;

    agInit(params: DragDropCellParams): void {
        this.params = params;
        this.colDef = this.params.column.getColDef() as GenericColDef;
        this.automationId = `${(this.colDef && this.colDef.automationId) ? this.colDef.automationId + '-' : ''}drag-drop-cell-${this.params.value ? this.params.value : 'empty-cell'}`;
    }

    refresh(): boolean {
        return false;
    }
}
